import { buildChartTheme } from '@visx/xychart';

export const customTheme = buildChartTheme({
  colors: ['#0A76AE', '#00FFCB'],
  backgroundColor: '#ebebeb',
  tickLength: 6,
  gridColor: '#ccc',
  gridColorDark: '#ccc',
});
